
<template>
    <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
        <span>{{name}}</span>
    </div>
        <div class="text item paramContainer">
            <el-row :gutter="10">
                <el-col class="paramNameCol" :span="8">
                    URI
                </el-col>
                <el-col :span="16">
                    <el-input
                        type="textarea"
                        placeholder="Please input URI"
                        v-model="uris"
                        clearable>
                    </el-input>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Plus domain
                </el-col>
                <el-col :span="16">
                    <el-checkbox class="clickCheckbox" v-model="model.params.plus_domain"></el-checkbox>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Region
                </el-col>
                <el-col :span="16">
                    <el-input
                        placeholder="Input region (text)"
                        v-model="model.params.lr"
                        clearable>
                    </el-input> 
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Mode
                </el-col>
                <el-col :span="16">
                     <el-select v-model="model.params.mode"  placeholder="Select mode">
                        <el-option
                        v-for="item in modes"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Search engine URI
                </el-col>
                <el-col :span="16">
                     <el-select v-model="model.params.se_uri"  placeholder="Select mode">
                        <el-option
                        v-for="item in engine"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Suggestions
                </el-col>
                <el-col :span="16">
                     <el-select v-model="model.params.use_suggestions"  placeholder="Select mode">
                        <el-option
                        v-for="item in suggestions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Page depth
                </el-col>
                <el-col :span="16">
                    <el-input-number size="mini" v-model="model.params.page_depth"></el-input-number>        
                </el-col>
            </el-row>
            <el-collapse v-model="collapso">
                <el-collapse-item title="Rejections" name="1">
                    <el-row :gutter="8">
                        <el-col class="paramNameCol" :span="8">
                            Rejections count min
                        </el-col>
                        <el-col :span="16">
                            <el-input-number size="mini" v-model="model.params.rejections_count_min"></el-input-number>        
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col class="paramNameCol" :span="8">
                            Rejections count max
                        </el-col>
                        <el-col :span="16">
                            <el-input-number size="mini" v-model="model.params.rejections_count_max"></el-input-number>        
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col class="paramNameCol" :span="8">
                            Minumum time on a rejected page
                        </el-col>
                        <el-col :span="16">
                            <el-input-number size="mini" v-model="model.params.rejection_min_time"></el-input-number>        
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col class="paramNameCol" :span="8">
                            Maximum time on a rejected page
                        </el-col>
                        <el-col :span="16">
                            <el-input-number size="mini" v-model="model.params.rejection_max_time"></el-input-number>        
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col class="paramNameCol" :span="8">
                            Reject only before target
                        </el-col>
                        <el-col :span="16">
                            <el-checkbox class="clickCheckbox" v-model="model.params.reject_only_before_target"></el-checkbox>        
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col class="paramNameCol" :span="8">
                            Rejection urls
                        </el-col>
                        <el-col :span="16">
                            <el-input
                                type="textarea"
                                placeholder="Please input rejection urls"
                                v-model="r_uris"
                                clearable>
                            </el-input>        
                        </el-col>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Required
                </el-col>
                <el-col :span="16">
                    <el-checkbox class="clickCheckbox" v-model="model.params.required"></el-checkbox>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Queries
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-input
                    type="textarea"
                    class="textarea-stripe-container"
                    placeholder="Please input search queries"
                    autosize
                    v-model="queries">
                </el-input>
            </el-row>
            <el-collapse v-model="collapso_advanced">
                <el-collapse-item title="Advanced options" name="1">
                    <el-row :gutter="8">
                        <el-col class="paramNameCol" :span="9">
                            Click random matching URL
                        </el-col>
                        <el-col :span="15">
                            <el-checkbox class="clickCheckbox" v-model="model.params.click_random_url_match"></el-checkbox>        
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col class="paramNameCol" :span="9">
                            Ignore URLs containing these strings
                        </el-col>
                        <el-col :span="15">
                            <el-input
                                type="textarea"
                                placeholder="Please input urls to ignore"
                                v-model="exclude_uris"
                                clearable>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col class="paramNameCol" :span="9">
                            Save organic search URLs
                        </el-col>
                        <el-col :span="15">
                            <el-checkbox class="clickCheckbox" v-model="model.params.save_organic_urls"></el-checkbox>        
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col class="paramNameCol" :span="9">
                            Topvisor Project ID
                        </el-col>
                        <el-col :span="15">
                            <el-input placeholder="Input Topvisor Project ID" v-model="model.params.tv_projectid" clearable></el-input>
                        </el-col>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
            <el-row>
                <div class="tip">
                    So you can specify what site you want to search via yandex, what exact instance of ya has to be used, also you can set a region and how many pages are gonna be analyzed.
                </div>
            </el-row>
        </div>
    </el-card>    
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'Yandex',
    props: {
        key: {
            type: Number
        },
        model: {
            type: Object,
            default: () => {}
        },
    },
    data () {
        return {
            name:'Search in Yandex',
            modes: ['random', 'table', 'uri_list', 'ads_click', 'positions_only'],
            collapso: false,
            collapso_advanced: false,
            engine: [
                {value:'https://ya.ru',     name: 'ya.ru'},
                {value:'direct_url',        name: 'direct url'},
                {value:'browser_widget',    name: 'browser widget'},
                {value:'https://yandex.ru', name: 'yandex.ru'},
                {value:'https://yandex.kz', name: 'yandex.kz'},
                {value:'https://yandex.kg', name: 'yandex.kg'},
                {value:'https://yandex.by', name: 'yandex.by'},
                {value:'https://yandex.uz', name: 'yandex.uz'},
                {value:'https://yandex.ua', name: 'yandex.ua'},
                {value:'https://yandex.com',name: 'yandex.com'},
                {value:'https://yandex.com.tr',name: 'yandex.com.tr'},
            ],
            suggestions: [
                {value:'never', name: 'never'},
                {value:'random', name: 'random'},
                {value:'always', name: 'always'},
            ],
            textarea: '',
            queries: this.prepareParam(this, 'values'),
            uris: this.prepareParam(this, 'uri'),
            r_uris: this.prepareParam(this, 'rejection_urls'),
            exclude_uris: this.prepareParam(this, 'exclude_urls'),
        }
    },

    methods: {
    },
    computed: {
        ...mapState('bot', {
        bot: 'bot',
        project: 'project',
        error: 'error',
        loading: 'loading',
        }),
    },
    watch: {
        queries(newValue, oldValue) {
            this.model.params.values = newValue.replace(/\r\n/g,"\n").split("\n");
        },
        uris(newValue, oldValue) {
            this.model.params.uri = newValue.replace(/\r\n/g,"\n").split("\n");
        },
        r_uris(newValue, oldValue) {
            this.model.params.rejection_urls = newValue.replace(/\r\n/g,"\n").split("\n");
        },
        exclude_uris(newValue, oldValue) {
            this.model.params.exclude_urls = newValue.replace(/\r\n/g,"\n").split("\n");
        },
    },
}
</script>

<style lang="scss" scoped>
    .clickCheckbox {
        margin-top: 10px;
    }
</style>
